import { useLocation } from 'react-router-dom';

import { Button } from '../components/ui.jsx';

/**
 * NotFound — catch-all for unmatched storefront paths.
 *
 * Shows the attempted path, which is genuinely useful when a shared product link
 * has a typo or a slug has been changed in the admin panel.
 */
export default function NotFound() {
  const { pathname } = useLocation();

  return (
    <div className="container-page grid min-h-[60vh] place-items-center py-16">
      <div className="max-w-md text-center">
        <p className="text-6xl font-bold tracking-tight text-brand-600">404</p>

        <h1 className="mt-4 text-2xl font-bold tracking-tight text-ink-950">This page does not exist</h1>

        <p className="mt-3 text-sm leading-relaxed text-ink-600">
          Nothing is served at{' '}
          <code className="rounded bg-ink-100 px-1.5 py-0.5 font-mono text-xs text-ink-800">{pathname}</code>. The
          link may be out of date, or the product may have been unpublished.
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Button to="/">Browse all phones</Button>
          <Button to="/how-it-works" variant="secondary">
            How it works
          </Button>
        </div>
      </div>
    </div>
  );
}
